/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste X,Y data pairs to build a scatter plot and see how two variables relate. Each row is one point, with the x value in the first column and the y value in the second.`)
};

const es_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega pares de datos X,Y para crear un diagrama de dispersión y ver cómo se relacionan dos variables. Cada fila es un punto, con el valor x en la primera columna y el valor y en la segunda.`)
};

const de_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie X,Y-Datenpaare ein, um ein Streudiagramm zu erstellen und zu sehen, wie zwei Variablen zusammenhängen. Jede Zeile ist ein Punkt, mit dem x-Wert in der ersten Spalte und dem y-Wert in der zweiten.`)
};

const nl_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak X,Y-datapaaren om een spreidingsdiagram te bouwen en te zien hoe twee variabelen samenhangen. Elke rij is één punt, met de x-waarde in de eerste kolom en de y-waarde in de tweede.`)
};

const fr_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez des paires de données X,Y pour créer un nuage de points et voir comment deux variables sont liées. Chaque ligne est un point, avec la valeur x dans la première colonne et la valeur y dans la seconde.`)
};

const it_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla coppie di dati X,Y per costruire un grafico a dispersione e vedere come si relazionano due variabili. Ogni riga è un punto, con il valore x nella prima colonna e il valore y nella seconda.`)
};

const pt_br2_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole pares de dados X,Y para criar um gráfico de dispersão e ver como duas variáveis se relacionam. Cada linha é um ponto, com o valor x na primeira coluna e o valor y na segunda.`)
};

const pt_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole pares de dados X,Y para construir um gráfico de dispersão e ver como duas variáveis se relacionam. Cada linha é um ponto, com o valor de x na primeira coluna e o valor de y na segunda.`)
};

const ja_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X, Yのデータペアを貼り付けると散布図が作成され、2つの変数がどう関連するかが分かります。1行が1つの点で、最初の列がx値、2番目の列がy値です。`)
};

const zh_scatter_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴 X,Y 数据对以构建散点图，查看两个变量之间的关系。每行为一个点，x 值在第一列，y 值在第二列。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_intro", locale)
	if (locale === "en") return en_scatter_intro(inputs)
	if (locale === "es") return es_scatter_intro(inputs)
	if (locale === "de") return de_scatter_intro(inputs)
	if (locale === "nl") return nl_scatter_intro(inputs)
	if (locale === "fr") return fr_scatter_intro(inputs)
	if (locale === "it") return it_scatter_intro(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_intro(inputs)
	if (locale === "pt") return pt_scatter_intro(inputs)
	if (locale === "ja") return ja_scatter_intro(inputs)
	return zh_scatter_intro(inputs)
};